<script lang="ts">
  import { onMount } from "svelte";
  import gsap from "gsap";

  export let invert: boolean;
  let counter3;

  onMount(() => {
    const counter3 = document.querySelector(".counter-3");
    for (let i = 0; i < 2; i++) {
      for (let j = 0; j < 10; j++) {
        const div = document.createElement("div");
        div.className = "num";
        //@ts-expect-error change num to string
        div.textContent = j;
        counter3.appendChild(div);
      }
    }
    const finalDiv = document.createElement("div");
    finalDiv.className = "num";
    finalDiv.textContent = "0";
    counter3.appendChild(finalDiv);

    function animate(counter: any, duration: any, delay = 0) {
      const numHeight = counter.querySelector(".num").clientHeight;
      const totalDistance =
        (counter.querySelectorAll(".num").length - 1) * numHeight;
      gsap.from(counter, {
        y: -totalDistance,
        duration: duration,
        delay: delay,
        ease: "power3.inOut",
      });
    }

    animate(counter3, 5);
    animate(document.querySelector(".counter-2"), 6);
    animate(document.querySelector(".counter-1"), 2, 2);
  });
</script>

<style lang="scss">
  .counter {
    font-family: "Proxima Nova";
    display: flex;
    font-size: 100px;
    line-height: 115.2px;
    clip-path: polygon(0 0, 100% 0, 100% 115.2px, 0 115.2px);
    font-weight: 500;
    margin-right: 6px;
    height: 86px;

    @media (min-width: $md) {
      margin-right: 39px;
    }
    @media (min-width: $lg) {
      font-size: 140px;
      line-height: 168px;
      clip-path: polygon(0 0, 100% 0, 100% 168px, 0 168px);
      margin-right: 71px;
      height: 125px;
    }
  }

  .counter-1,
  .counter-2,
  .counter-3 {
    position: relative;
    color: $on-surface;
  }

  .counter-1--invert,
  .counter-2--invert,
  .counter-3--invert {
    color: $inverse-on-surface !important;
  }

  .num1offset1 {
    position: relative;
    right: -4px;
    @media (min-width: $md) {
      right: -12px;
    }
    @media (min-width: $lg) {
      right: -15px;
    }
  }

  .num1offset2 {
    position: relative;
    right: -10px;
  }
</style>

<div class="counter" bind:this={counter3}>
  <div class={`counter-1 ${invert && "counter-1--invert"}`}>
    <div class="num num1offset1">1</div>
    <div class="num">0</div>
  </div>
  <div class={`counter-2 ${invert && "counter-2--invert"}`}>
    <div class="num">0</div>
    <div class="num">9</div>
    <div class="num">8</div>
    <div class="num">7</div>
    <div class="num">6</div>
    <div class="num">5</div>
    <div class="num">4</div>
    <div class="num">3</div>
    <div class="num">2</div>
    <div class="num num1offset2">1</div>
    <div class="num">0</div>
  </div>
  <div class={`counter-3 ${invert && "counter-3--invert"}`}>
    <div class="num">0</div>
  </div>
</div>
